<template>
	<div class="modal-holder" :class="{'is-closing': isClosing}">
		<div class="modal-backdrop" @click="close()"></div>
		<div class="modal">
			<div class="modal-close" @click="close()"><svg><use xlink:href="#cross"></use></svg></div>
			<!--<slot></slot>-->
			<router-view></router-view>
			<div class="modal-loader" v-if="isLoading">
				<loader></loader>
			</div>
		</div><!-- end.modal -->
	</div>
</template>
<script>
	import Loader from './Loader'

	export default {
		components: {
			Loader
		},
		data() {
			return {
				isClosing: false,
				isLoading: false,
			}
		},
		methods: {
			close() {
				this.isClosing = true;
				setTimeout(() => {
					this.$emit('close');
				}, 300);
			}
		},
		mounted() {
			this.$on('toggle-loading', (state) => {
				this.isLoading = state;
			})
		}
	}
</script>
